import { api } from "../base";

// Served verbatim by trading-ops-server GET /api/trading-ops/v1/halo-defaults;
// 404 when no halo_defaults block is configured for the environment.
export interface IHaloDefaults {
  risk_subaccount?: string;
  liquidity_provider?: string;
  lender?: string;
  loan_lender_account_filter?: string[];
}

const haloDefaultsEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    getHaloDefaults: build.query<IHaloDefaults, void>({
      query: () => ({
        url: "/api/trading-ops/v1/halo-defaults",
      }),
      providesTags: ["HaloDefaults"],
    }),
  }),
});

export const { useGetHaloDefaultsQuery } = haloDefaultsEndpoints;
